(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store"]) return;
  try {
    
  
(function($) {

  $(function() {

    const endpoints = {
      'IN': 'https://about.redtape.com/locator/location.php?country=india',
      'NP': 'https://about.redtape.com/locator/location.php?country=nepal',
      'AE': 'https://about.redtape.com/locator/location.php?country=uae',
      'LK': 'https://about.redtape.com/locator/location.php?country=sri lanka'
    };

    function getCountryUrl(code) {
      return endpoints[(code || 'IN').toUpperCase()] || endpoints['IN'];
    }

    const $state = $('#location-state');
    const $city = $('#location-city');
    const $searchBtn = $('#search-store-btn');
    const $allContainer = $('#all-cities-container');
    const $filtered = $('#filtered-results');

    // TITLE CASE
    function toTitleCase(str) {
      return (str || '')
        .toLowerCase()
        .replace(/\b\w/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1);
        });
    }

    // ESCAPE HTML
    function escapeHtml(text) {
      return (text || '').toString()
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    // LOAD STATES
    function loadStates(countryCode = 'IN') {

      const url = getCountryUrl(countryCode);

      $state.prop('disabled', true)
        .html('<option value="">Loading states...</option>');

      $.ajax({
        url,
        type: 'post',
        dataType: 'text',

        success: function(resp) {

          try {

            const parsed = JSON.parse(resp);

            if (!Array.isArray(parsed.stateList)) {
              throw new Error('stateList missing');
            }

            let options = '<option value="">Select state</option>';

            parsed.stateList.forEach(function(s) {

              options += `
                <option value="${escapeHtml(s)}">
                  ${escapeHtml(toTitleCase(s))}
                </option>
              `;

            });

            $state.html(options).prop('disabled', false);

            loadAllCities(parsed.stateList);

          } catch {

            $state.html('<option value="">Failed to load states</option>');

          }

        },

        error: function() {

          $state.html('<option value="">Failed to load states</option>');

        }

      });

    }

    // LOAD CITIES
    function loadCitiesForDropdown(stateName) {

      if (!stateName) return;

      const url = `https://about.redtape.com/locator/getCity.php?city=${encodeURIComponent(stateName)}`;

      $city.prop('disabled', true)
        .html('<option>Loading cities...</option>');

      $.ajax({

        url,
        type: 'post',
        dataType: 'html',

        success: function(html) {

          const $temp = $('<select>').html(html);

          let newOptions = '<option value="">Select city</option>';

          $temp.find('option').each(function() {

            const val = $(this).val();

            if (val) {

              newOptions += `
                <option value="${escapeHtml(val)}">
                  ${escapeHtml(toTitleCase(val))}
                </option>
              `;

            }

          });

          $city.html(newOptions).prop('disabled', false);

        },

        error: function() {

          $city.html('<option value="">Unable to load cities</option>')
            .prop('disabled', false);

        }

      });

    }

    // STORE COUNT
    async function getStoreCount(state, city) {

      try {

        const url = `https://about.redtape.com/locator/location.php?country=india&state=${encodeURIComponent(state)}&city=${encodeURIComponent(city)}`;

        const resp = await $.ajax({
          url,
          type: 'post',
          dataType: 'text'
        });

        const parsed = JSON.parse(resp);

        return parsed.addressList ? parsed.addressList.length : 0;

      } catch {

        return 0;

      }

    }

    // LOAD ALL CITIES
    function loadAllCities(stateList) {

      if (!Array.isArray(stateList) || !stateList.length) return;

      $allContainer.html('<p class="loading">Loading full city list...</p>');

      const promises = stateList.map(function(state) {

        const url = `https://about.redtape.com/locator/getCity.php?city=${encodeURIComponent(state)}`;

        return $.ajax({
          url,
          type: 'post',
          dataType: 'html'
        })

        .then(async function(cityHtml) {

          const $tmp = $('<select>').html(cityHtml);

          let cities = [];

          $tmp.find('option').each(function() {

            if ($(this).val()) {
              cities.push($(this).val());
            }

          });

          const cityCount = cities.length;

          let block = `
            <div class="state-block">

              <h3>

                <span>
                  ${escapeHtml(toTitleCase(state))}

                  <span style="font-size:13px; color:#fff;">
                    (${cityCount} ${cityCount > 1 ? 'Cities' : 'City'})
                  </span>

                </span>

                <span class="icon">+</span>

              </h3>

              <ul style="display:none;">
          `;

          for (const city of cities) {

            const count = await getStoreCount(state, city);

            block += `
              <li class="city-item clickable"
                  data-state="${escapeHtml(state)}"
                  data-city="${escapeHtml(city)}">

                ${escapeHtml(toTitleCase(city))}

                <span style="color:#777;">
                  (${count} Store${count !== 1 ? 's' : ''})
                </span>

              </li>
            `;

          }

          block += `
              </ul>
            </div>
          `;

          return block;

        })

        .catch(function() {

          return `
            <div class="state-block">

              <h3>
                ${escapeHtml(toTitleCase(state))}
                <span class="icon">+</span>
              </h3>

              <p class="loading">
                Failed to load cities
              </p>

            </div>
          `;

        });

      });

      Promise.all(promises)

      .then(function(blocks) {

        $allContainer.html(blocks.join(''));

      })

      .catch(function() {

        $allContainer.html('<p class="loading">Failed to load full city list.</p>');

      });

    }

    // SEARCH
    function doSearch(state, city) {

      if (!state || !city) {
        alert('Please select State and City');
        return;
      }

      $filtered.html('<p class="loading">Loading stores...</p>');

      $searchBtn.prop('disabled', true);

      const url = `https://about.redtape.com/locator/location.php?country=india&state=${encodeURIComponent(state)}&city=${encodeURIComponent(city)}`;

      $.ajax({

        url,
        type: 'post',
        dataType: 'text',

        success: function(resp) {

          try {

            const parsed = JSON.parse(resp);

            if (!parsed.addressList || !parsed.addressList.length) {

              $filtered.html('<p>No stores found in this area.</p>');

              return;

            }

            let html = '';

            parsed.addressList.forEach(function(addr) {

              const mapUrl = addr.direction
                ? addr.direction
                : `https://www.google.com/maps?q=${encodeURIComponent(addr.name + ' ' + addr.address)}`;

              html += `
                <div class="store">

                  <h4>${escapeHtml(addr.name || '')}</h4>

                  <p>${escapeHtml(addr.address || '')}</p>

                  <a href="tel:${escapeHtml(addr.telephone || '')}" target="_blank">
                    ${escapeHtml(addr.telephone || '')}
                  </a>

                  <a href="${mapUrl}" target="_blank" class="btn-map">
                    Get Directions
                  </a>

                </div>
              `;

            });

            $filtered.html(html);

          } catch {

            $filtered.html('<p>Failed to load stores.</p>');

          }

        },

        complete: function() {

          $searchBtn.prop('disabled', false);

        }

      });

    }

    // ACCORDION
    $allContainer.on('click', '.state-block > h3', function() {

      const $clicked = $(this).parent();

      $clicked
        .siblings('.state-block.open')
        .removeClass('open')
        .find('ul')
        .slideUp();

      $clicked
        .siblings('.state-block')
        .find('.icon')
        .text('+');

      $clicked.toggleClass('open');

      $clicked.find('ul').slideToggle();

      $clicked.find('.icon')
        .text($clicked.hasClass('open') ? '−' : '+');

    });

    // CITY CLICK
    $allContainer.on('click', '.city-item', function() {

      const $cityEl = $(this);

      const st = $cityEl.data('state');
      const ct = $cityEl.data('city');

      if ($cityEl.next('.inline-result').length) {

        $cityEl.next('.inline-result').slideToggle();

        return;

      }

      $cityEl.after('<div class="inline-result"><em>Loading stores...</em></div>');

      const url = `https://about.redtape.com/locator/location.php?country=india&state=${encodeURIComponent(st)}&city=${encodeURIComponent(ct)}`;

      $.ajax({

        url,
        type: 'post',
        dataType: 'text',

        success: function(resp) {

          try {

            const parsed = JSON.parse(resp);

            if (!parsed.addressList || !parsed.addressList.length) {

              $cityEl.next('.inline-result')
                .html('<p>No stores found here.</p>');

              return;

            }

            let html = '';

           parsed.addressList.forEach(function(addr) {

  const storeName = addr.name || "Store";
  const address = addr.address || "Address not available";
  const phone = addr.telephone || "Not Available";

  const mapUrl = addr.direction
    ? addr.direction
    : `https://www.google.com/maps?q=${encodeURIComponent(storeName + ' ' + address)}`;

  html += `
    <div class="store">
      <h4>${escapeHtml(storeName)}</h4>

      <p>${escapeHtml(address)}</p>

      ${
        addr.telephone
          ? `<a href="tel:${escapeHtml(addr.telephone)}">${escapeHtml(addr.telephone)}</a>`
          : `<span>${phone}</span>`
      }

      <a href="${mapUrl}" target="_blank" class="btn-map">
        Get Directions
      </a>
    </div>
  `;
});

            $cityEl.next('.inline-result').html(html);

          } catch {

            $cityEl.next('.inline-result')
              .html('<p style="color:red">Error loading stores.</p>');

          }

        }

      });

    });

    // EVENTS
    $state.on('change', function() {

      loadCitiesForDropdown($(this).val());

    });

    $searchBtn.on('click', function(e) {

      e.preventDefault();

      doSearch($state.val(), $city.val());

    });

    $('body').on('click', '.country-loc-drop ul li a', function(e) {

      e.preventDefault();

      const selectedCode = $(this).data('val');

      const countryName = $(this).text().trim();

      $('.flagstrap-selected').html(
        `<i class="flagstrap-icon flagstrap-${selectedCode.toLowerCase()}" style="margin-right:10px;"></i> ${countryName}`
      );

      $('.country-loc-drop').removeClass('open');

      loadStates(selectedCode);

    });

    $('body').on('click', '.dropdown-toggle', function() {

      $('.country-loc-drop')
        .not($(this).parent('.country-loc-drop'))
        .removeClass('open');

      $(this).parent('.country-loc-drop')
        .toggleClass('open');

    });

    // INITIAL LOAD
    loadStates();

  });

})(jQuery);

// CLOSE DROPDOWN
$(document).on('click', function(e) {

  if (!$(e.target).closest('.country-loc-drop').length) {

    $('.country-loc-drop').removeClass('open');

  }

});


  } catch(e) { console.error(e); }
})();
})();
